var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseBigNumber',_vm._b({attrs:{"number":_vm.number,"title":_vm.title,"subnumber":_vm.subnumber,"subnumber-description":_vm.subnumberDescription,"tooltip":_vm.tooltip,"type":_vm.type,"loading":_vm.loading}},'BaseBigNumber',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }